export default {
      id: "symbol-defs-usage",
      viewBox: undefined,
      url: __webpack_public_path__ + "icons.svg#symbol-defs",
      toString: function () {
        return this.url;
      }
    }